module.exports = __webpack_public_path__ + "img/what-is-ooca-side.01eafd72.png";